module.exports = __webpack_public_path__ + "img/dillan_johnson_valley_of_fire.c5202ad9.jpg";